import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import ProfileDropdown from './ProfileDropdown'
import {
  getIdentityUserData,
  getIdentityActiveRoleName,
  getIdentityAvatar,
  getIdentityRoles,
  isOrganizationHasStories,
} from 'store/entities/identity/selectors'
import { logoutRequest, switchRole } from 'store/entities/identity/actions'

const mapStateToProps = createStructuredSelector({
  userProfile: getIdentityUserData,
  roleName: getIdentityActiveRoleName,
  avatar: getIdentityAvatar,
  roles: getIdentityRoles,
  isStoryActivatedForOrganization: isOrganizationHasStories,
})

const mapDispatchToProps = {
  onLogout: logoutRequest,
  switchRole,
}

const ProfileDropdownContainer = connect(mapStateToProps, mapDispatchToProps)(withTranslation('user')(ProfileDropdown))

ProfileDropdownContainer.displayName = 'ProfileDropdownContainer'

export default ProfileDropdownContainer
